<template>
  <div class="layout-form">
    <error-reveal :error="uierror"></error-reveal>
    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save">
      <div class="row">
        <div class="small-4 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded" v-if="analytics">
        <div class="small-12 medium-6 columns">
          <label error-path="channels">
            Felhasználó:
          </label>
          <select-input v-model="data.selectedUser" :options="users" valueField="id" titleField="displayName"></select-input>
        </div>
      </div>

      <div class="row expanded" v-if="analytics && data.selectedUser">
        <div class="small-12 medium-6 columns">
          <label error-path="channels">
            Engedélyezett oldalak:
          </label>
          <channel-cards v-model="data.selectedChannels" :channels="channels"></channel-cards>
        </div>
      </div>

      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase" v-if="analytics && data.selectedUser">Mentés</button>
          <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import Promise from 'bluebird'
import { mapMutations, mapState } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import SelectInput from '../../inputs/select-input'
import ChannelCards from '../../inputs/channel-cards'
import ErrorReveal from '../../errors/Reveal'
import {editInsightsSettings as validationSchema} from '../../../schemas'
import userService from '../../services/user'
import analyticsService from '../../services/analytics'
import insightsService from '../../services/insights'

export default {
  name: 'insights-share',
  components: {
    JoiForm,
    ErrorReveal,
    ChannelCards,
    SelectInput
  },
  data () {
    return {
      data: {
        selectedUser: null,
        selectedChannels: []
      },
      validationSchema,
      formError: null,
      uierror: null,
      existingUser: false,
      users: [],
      channels: [],
      analytics: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  created: function () {
    this.load()
  },
  watch: {
    'data.selectedUser': function (userId) {
      this.loadShare()
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    back () {
      this.$router.push({name: 'insights-query'})
    },
    load (id) {
      this.reset()
      this[mutationTypes.BUSY_ON]()

      Promise.all([
        userService.list(),
        insightsService.loadSettings()
      ]).spread((usersResponse, settingsResponse) => {
        this[mutationTypes.BUSY_OFF]()
        this.users = this.prepareFetchedUsers(usersResponse)
        this.channels = this.prepareFetchedChannels(settingsResponse)

        if (settingsResponse && settingsResponse.analytics && settingsResponse.analytics.state === 'completed') {
          this.analytics = settingsResponse.analytics
        } else {
          this.analytics = null
          this.uierror = new Error('Nincs rendelkezésre álló adat, megosztás nem lehetséges.')
        }
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      var payload = {
        user: formData.selectedUser,
        channels: formData.selectedChannels
      }
      this[mutationTypes.BUSY_ON]()
      analyticsService.saveShare(this.analytics._id, payload).then((result) => {
        window.setTimeout(() => {
          this[mutationTypes.BUSY_OFF]()
        }, 500)
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    },
    prepareFetchedUsers (usersResponse) {
      return (usersResponse && usersResponse.users)
        ? usersResponse.users.reduce((accumulator, currentValue) => {
          if (currentValue.id !== this.user.id) {
            accumulator.push(currentValue)
          }
          return accumulator
        }, [])
        : []
    },
    prepareFetchedChannels (settingsResponse) {
      return (settingsResponse && settingsResponse.channels)
        ? settingsResponse.channels.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue)
          return accumulator
        }, [])
        : []
    },
    loadShare () {
      var payload = {
        user: this.data.selectedUser
      }
      this[mutationTypes.BUSY_ON]()
      analyticsService.loadShare(this.analytics._id, payload).then((result) => {
        this[mutationTypes.BUSY_OFF]()
        this.data.selectedChannels = result.data
          ? result.data.channels
          : []
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Share.vue?10a13180